import React, { useEffect, useState } from 'react';
import { produitsService } from '../services/api';
import { useFormatage } from '../hooks/useAgroshopHooks';

const UNITS = [
  { value: 'kg', label: 'kg' },
  { value: 'sac_50kg', label: 'Sac 50kg' },
  { value: 'sac_25kg', label: 'Sac 25kg' },
  { value: 'sac_10kg', label: 'Sac 10kg' },
  { value: 'sac_5kg', label: 'Sac 5kg' },
  { value: 'sachet', label: 'Sachet' },
  { value: 'litre', label: 'Litre' },
  { value: 'bidon_5l', label: 'Bidon 5L' },
  { value: 'bidon_20l', label: 'Bidon 20L' },
  { value: 'unite', label: 'Unité' },
];

export default function AddProductPanel({ onCreated }) {
  const { formatPrix } = useFormatage();
  const [categories, setCategories] = useState([]);
  const [form, setForm] = useState({
    reference: '',
    nom: '',
    categorie: '',
    description_courte: '',
    description: '',
    prix_unitaire: '',
    quantite_stock: '',
    unite: 'unite',
    seuil_alerte: '10',
    en_vedette: false,
    nouveau: false,
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    produitsService.getCategories()
      .then((data) => {
        const items = Array.isArray(data) ? data : (data?.results || []);
        setCategories(items);
      })
      .catch(() => setCategories([]));
  }, []);

  const handleChange = (field) => (event) => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      const payload = {
        ...form,
        prix_unitaire: Number(form.prix_unitaire) || 0,
        quantite_stock: Number(form.quantite_stock) || 0,
        seuil_alerte: Number(form.seuil_alerte) || 0,
      };
      const produit = await produitsService.create(payload);
      setMessage(`Produit ${produit.nom} créé avec succès.`);
      setForm((prev) => ({ ...prev, reference: '', nom: '', description_courte: '', description: '', prix_unitaire: '', quantite_stock: '', categorie: '', en_vedette: false, nouveau: false }));
      if (onCreated) onCreated(produit);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="ag-dashboard-panel">
      <div className="ag-dashboard-panel-header">
        <div>
          <h3>Ajouter un produit</h3>
          <p className="ag-muted">Créez un nouveau produit dans le catalogue.</p>
        </div>
      </div>

      <form className="ag-form" onSubmit={handleSubmit}>
        <label>
          Référence
          <input type="text" value={form.reference} onChange={handleChange('reference')} required />
        </label>
        <label>
          Nom du produit
          <input type="text" value={form.nom} onChange={handleChange('nom')} required />
        </label>
        <label>
          Catégorie
          <select value={form.categorie} onChange={handleChange('categorie')} required>
            <option value="">Sélectionner une catégorie</option>
            {categories.map((categorie) => (
              <option key={categorie.id} value={categorie.id}>
                {categorie.icone ? `${categorie.icone} ` : ''}{categorie.nom}
              </option>
            ))}
          </select>
        </label>
        <label>
          Description courte
          <textarea value={form.description_courte} onChange={handleChange('description_courte')} rows="2" required />
        </label>
        <label>
          Description complète
          <textarea value={form.description} onChange={handleChange('description')} rows="4" />
        </label>
        <label>
          Prix unitaire (FCFA)
          <input type="number" min="1" value={form.prix_unitaire} onChange={handleChange('prix_unitaire')} required />
        </label>
        <label>
          Quantité en stock
          <input type="number" min="0" value={form.quantite_stock} onChange={handleChange('quantite_stock')} required />
        </label>
        <label>
          Unité
          <select value={form.unite} onChange={handleChange('unite')}>
            {UNITS.map((unit) => (
              <option key={unit.value} value={unit.value}>{unit.label}</option>
            ))}
          </select>
        </label>
        <label>
          Seuil d'alerte
          <input type="number" min="0" value={form.seuil_alerte} onChange={handleChange('seuil_alerte')} />
        </label>
        <label>
          <input type="checkbox" checked={form.en_vedette} onChange={handleChange('en_vedette')} /> Mise en vedette
        </label>
        <label>
          <input type="checkbox" checked={form.nouveau} onChange={handleChange('nouveau')} /> Nouveau
        </label>
        <div className="ag-form-actions">
          <button type="submit" className="ag-btn" disabled={loading}>
            {loading ? 'Création...' : 'Créer le produit'}
          </button>
        </div>
      </form>

      {message && <div className="ag-alert">{message}</div>}
      {error && <div className="ag-alert ag-alert-error">{error}</div>}
    </section>
  );
}
